import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import LoadingOverlay from '../LoadingOverlay';
import { hasRequiredRole } from '../../../utils/auth/rbac';

export default function PrivateRoute({
  children,
  requiredRoles = [],
  ...rest
}) {
  const { authState } = useOktaAuth();

  return (
    <Route
      {...rest}
      render={({ location }) => {
        // Show loading state while authenticating
        if (!authState || authState.isPending) {
          return <LoadingOverlay />;
        }

        // If not authenticated, redirect to login
        if (!authState.isAuthenticated) {
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: location },
              }}
            />
          );
        }

        // If no specific roles required, allow access
        if (requiredRoles.length === 0) {
          return children;
        }

        // For role-based access, we'll use a simpler approach
        // In a real implementation, you'd check user roles here
        // For now, we'll allow access for authenticated users
        // TODO: Implement proper role checking when user claims are available
        return children;
      }}
    />
  );
}
